import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import QRCode from 'qrcode';
@Injectable({
	providedIn: 'root'
})

export class CommonService {

	constructor(private cookieService: CookieService) { }

	/**
	 * Function to update theme in cookie
	 * @param {boolean} theme
	 */
	updateThemeData(theme: boolean) {
		if(theme) {
			this.cookieService.set('darkTheme', 'true');
		}
		else {
			this.cookieService.delete('darkTheme');
		}
		this.setThemeFromTheme();
	}

	/**
	 * Function to check current theme
	 */
	checkCurrentTheme() {
		let themeCookie = this.cookieService.get('darkTheme');

		if(themeCookie) {
			return true;
		}
		else {
			return false;
		}
	}

	setThemeFromTheme(){

		let hasDarkTheme = this.checkCurrentTheme();

		if(hasDarkTheme){
			document.querySelector('body').classList.add('dark-theme');
		}
		else {
			document.querySelector('body').classList.remove('dark-theme');
		}
	}
	async generateQRCode(text: string, options?: { width?: number, margin?: number }): Promise<string> {
		try {
		 const qrCodeDataURL = await QRCode.toDataURL(text, options);
			return qrCodeDataURL;
		} catch (err) {
			console.error('Error generating QR code', err);
			throw err;
		}
	}
}
